// eslint-disable-next-line import/no-cycle
import { LanguageState } from './reducer';
// eslint-disable-next-line import/no-cycle
import { RootState } from '../../index';

export const selectCurrentLanguage = (state: RootState): LanguageState['lang'] => state.public.i18n.lang;
